module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.checkins && _vm.checkins.length > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.checkins.length))]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Course Alerts"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Find your time sensitive course alerts below'),
      expression: "'Find your time sensitive course alerts below'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [(_vm.open === true) ? _c('i', {
    staticClass: "fa fa-minus"
  }) : _c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "panel-body"
  }, [(_vm.checkins && _vm.checkins.length > 0) ? _c('ul', {
    staticClass: "class-alerts clearfix path-alert"
  }, _vm._l((_vm.checkins), function(checkin) {
    return (_vm.isFirstInWeek(checkin)) ? _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'mentorCheckins',
          query: {
            id: checkin.id
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/bullhorn.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-text"
    }, [_c('span', {
      staticClass: "alert-name"
    }, [_vm._v("Check-in for Week " + _vm._s(checkin.week))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("checkinDate")(checkin.dueDate))), _c('br'), _vm._v(" "), (_vm.isOverdue(checkin.dueDate)) ? _c('span', {
      staticClass: "overdue"
    }, [_vm._v("Overdue")]) : _c('countdown', {
      attrs: {
        "date": checkin.dueDate,
        "fast": true
      }
    })], 1)])], 1) : _vm._e()
  })) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-047d717c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/MentorAlerts.vue
// module id = 1942
// module chunks = 2